const mutations = {

    setRoles(state,data){
        state.roleList = data;
    },
    setRole(state,data){
        state.role=data
    },
    resetRole(state){
        state.role = {
            label : '',
        }
    }
}

export default mutations;